module.exports = __webpack_public_path__ + "img/logo_umc.1bd946f2.jpg";